import { FormControlLabel } from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { TbLockPassword } from "react-icons/tb";
import { SlReload } from "react-icons/sl";
import { FaCircleInfo } from "react-icons/fa6";

export const ccmodeUserTableColumns = (
    setDeleteObj,
    setSwalOpen,
    handleToggle,
    setInviteUserForm,
    setUpdatePassword,
    setRecoverObj
) => [
    {
        Header: "Name",
        accessor: "display_name",
        className: "align-middle",
    },
    {
        Header: "Email",
        accessor: "email",
        className: "align-middle",
    },
    {
        Header: "Login On/Off",
        accessor: (user) => {
            const deleteStatus = JSON.parse(user.deleteStatus);
            return (
                <>
                    <FormControlLabel
                        className="m-0"
                        control={
                            <label className="switch switch-sm" style={{
                                marginBottom: "0px"
                            }}>
                                <input
                                    type="checkbox"
                                    className="success"
                                    disabled={
                                        user.is_default_user ||
                                        deleteStatus?.is_deleted
                                    }
                                    checked={user.is_active}
                                    onChange={() => handleToggle(user)}
                                    value={user.is_active}
                                />
                                <span className="slider" />
                            </label>
                        }
                        labelPlacement="start"
                        label={<span className="mr-3 ">{user.is_active ? "On" : "Off"}</span>}
                    />
                </>
            );
        },
        className: "align-middle text-center",
    },
    {
        Header: "Action",
        accessor: (user) => {
            const deleteStatus = JSON.parse(user.deleteStatus);

            const deleteUser = (user) => {
                setSwalOpen(true);
                setDeleteObj({
                    id: user.id,
                });
            };

            const EditUser = (user) => {
                setInviteUserForm((prev) => {
                    return {
                        isOpen: true,
                        userObj: {
                            id: user.id,
                            customerId: JSON.parse(
                                localStorage.getItem("userData")
                            ).CustomerId,
                            email: user.email,
                            permissions: user.permissions.map((el) => el.id),
                            displayName: user.display_name,
                            isDefaultUser: user.is_default_user,
                        },
                        isUpdating: true,
                        setPassword: null,
                    };
                });
            };

            const setPassword = (user) => {
                setUpdatePassword((prev) => ({
                    id: user.id,
                    customer_id: user.customer_id,
                    email: user.email,
                    isOpen: true,
                }));
            };

            return deleteStatus?.is_deleted ? (
                deleteStatus?.is_recoverable && (
                    <div className="d-flex justify-content-center">
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    Click to recover user
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-text-dark btn-hover-light-dark btn-icon"
                                onClick={() =>
                                    setRecoverObj({
                                        open: true,
                                        userId: user.id,
                                    })
                                }
                            >
                                <SlReload className="font-size-h5" />
                            </button>
                        </OverlayTrigger>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    you have {deleteStatus?.is_recoverable_days}{" "}
                                    days to recover
                                </Tooltip>
                            }
                        >
                            <button className="btn btn-text-dark btn-hover-light-dark btn-icon">
                                <FaCircleInfo className="font-size-h5" />
                            </button>
                        </OverlayTrigger>
                    </div>
                )
            ) : (
                <div className="d-flex justify-content-center">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip">Click to edit user</Tooltip>
                        }
                    >
                        <button
                            className="btn btn-text-dark btn-hover-light-dark btn-icon"
                            onClick={() => EditUser(user)}
                        >
                            <FaRegEdit className="font-size-h5" />
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip">Set Password</Tooltip>}
                    >
                        <button
                            className="btn btn-text-dark btn-hover-light-dark btn-icon"
                            onClick={() => setPassword(user)}
                        >
                            <TbLockPassword className="font-size-h5" />
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip">
                                {user.is_default_user
                                    ? "Cannot Delete Default User"
                                    : "Click to delete user"}
                            </Tooltip>
                        }
                    >
                        <button
                            className="btn btn-text-dark btn-hover-light-dark btn-icon"
                            onClick={() => deleteUser(user)}
                            disabled={user.is_default_user}
                        >
                            <FaRegTrashAlt className="font-size-h5" />
                        </button>
                    </OverlayTrigger>
                </div>
            );
        },
        className: "text-center align-middle",
    },
];
